import React from "react";

export default function HighlightText({ text, query, className = "" }) {
    const value = text == null ? "" : String(text);
    const q = (query || "").trim();
    if (!q) return <span className={className}>{value}</span>;

    const lower = value.toLowerCase();
    const needle = q.toLowerCase();
    const parts = [];
    let idx = 0;

    while (idx < value.length) {
        const hit = lower.indexOf(needle, idx);
        if (hit === -1) {
            parts.push(value.slice(idx));
            break;
        }
        if (hit > idx) parts.push(value.slice(idx, hit));
        parts.push(<mark key={`${hit}-${idx}`} className="rounded bg-warning/20 text-foreground px-0.5">{value.slice(hit, hit + needle.length)}</mark>);
        idx = hit + needle.length;
    }

    return <span className={className}>{parts.length ? parts : value}</span>;
}
